export const attachCoveoUA = function (c, o, v, e, O, u, a) {
	a = "coveoua";
	c[a] =
		c[a] ||
		function () {
			(c[a].q = c[a].q || []).push(arguments);
		};
	c[a].t = Date.now();
	u = o.createElement(v);
	u.async = 1;
	u.src = e;
	O = o.getElementsByTagName(v)[0];
	O.parentNode.insertBefore(u, O);
};

export const findPageInformationObject = (datalayer) => {
	for (let index = 0; index < datalayer.length; index++) {
		const currentObject = datalayer[index];

		if ("shortId" in currentObject) {
			return currentObject;
		}
	}
};
